import React from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";



function CarouselClients() {
  return (
    <div className="pt-10 bg-[#231E3D]">
      <Carousel>
        <div className="grid lg:grid-cols-2 gap-10">
          <img src="https://zesty-cajeta-af510d.netlify.app/image-33.svg" />
          <div className="text-left">
            <div className="text-transparent bg-clip-text bg-gradient-to-b from-[#6664F1] to-[#C94AF0] text-9xl rotate-6">
              "
            </div>
            <h1 className="text-white lg:text-3xl text-2xl">
              Dream house isn't dream anymore
            </h1>
            <p className="pt-4 text-[#ccc]">
              AltexSoft has been supporting our business for the past 9 months
              in both the creation and implementation of new and tailored
              software. We have worked with several of their developers and
              cannot speak highly enough of the team. They are reliable,
              thorough, smart, available, extremely good communicators and very
              friendly! We would recommend hiring Altexsoft to anyone looking
              for a highly productive and solution driven team. We plan to
              continue to work with them for the long term.
            </p>
            <h2 className="text-white text-2xl pt-4">Jassir Jones</h2>
            <p className="text-[#696984] pb-10">
              Chief Technology Officer, Google
            </p>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 gap-10">
          <img src="https://zesty-cajeta-af510d.netlify.app/image-33.svg" />
          <div className="text-left">
            <div className="text-transparent bg-clip-text bg-gradient-to-b from-[#6664F1] to-[#C94AF0] text-9xl rotate-6">
              "
            </div>
            <h1 className="text-white lg:text-3xl text-2xl">
              Dream house isn't dream anymore
            </h1>
            <p className="pt-4 text-[#ccc]">
              AltexSoft has been supporting our business for the past 9 months
              in both the creation and implementation of new and tailored
              software. We have worked with several of their developers and
              cannot speak highly enough of the team. They are reliable,
              thorough, smart, available, extremely good communicators and very
              friendly! We would recommend hiring Altexsoft to anyone looking
              for a highly productive and solution driven team. We plan to
              continue to work with them for the long term.
            </p>
            <h2 className="text-white text-2xl pt-4">Jassir Jones</h2>
            <p className="text-[#696984] pb-10">
              Chief Technology Officer, Google
            </p>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 gap-10">
          <img src="https://zesty-cajeta-af510d.netlify.app/image-33.svg" />
          <div className="text-left">
            <div className="text-transparent bg-clip-text bg-gradient-to-b from-[#6664F1] to-[#C94AF0] text-9xl rotate-6">
              "
            </div>
            <h1 className="text-white lg:text-3xl text-2xl">
              Dream house isn't dream anymore
            </h1>
            <p className="pt-4 text-[#ccc]">
              AltexSoft has been supporting our business for the past 9 months
              in both the creation and implementation of new and tailored
              software. We have worked with several of their developers and
              cannot speak highly enough of the team. They are reliable,
              thorough, smart, available, extremely good communicators and very
              friendly! We would recommend hiring Altexsoft to anyone looking
              for a highly productive and solution driven team. We plan to
              continue to work with them for the long term.
            </p>
            <h2 className="text-white text-2xl pt-4">Jassir Jones</h2>
            <p className="text-[#696984] pb-10">
              Chief Technology Officer, Google
            </p>
          </div>
        </div>
      </Carousel>
    </div>
  );
}

export default CarouselClients